import Api from "./api"
import Source from "./source"
import Device from "./device"
import App from "./app"
import _Event from "./event"
import Multicast from "./multicast"
import Hls from "./hls"
import Common from "./common"

class Vestel {
  constructor() {
    const model = navigator.userAgent.match(/VSTVB ([A-Za-z0-9._-]+)/)?.pop()

    this._api = new Api()
    this._source = new Source()
    this._device = new Device()
    this._common = new Common()
    this._app = new App()
    this._event = new _Event()
    this._multicast = new Multicast()
    this._rf = this._multicast
    this._hls = model === "MB100" ? this._multicast : new Hls()
    this._vod = model === "MB100" ? this._multicast : this._hls
  }
}

export default new Vestel()
